import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import env from './config/env';
import router from './router';
import { getCanal } from './helpers/helpers';

export default {
  methods: {
    analyticAccept() {
      console.log('Enabled Google Analytics');
      Vue.use(VueAnalytics, {
        id: env.GA,
        router,
        ignoreRoutes: ['/login', '/404'],
        disabled: false,
        debug: {
          enabled: false,
          trace: true,
          sendHitTask: true,
        },
        autoTracking: {
          pageviewTemplate(route) {
            return {
              title: document.title,
              page: route.path,
              location: window.location.href,
            };
          },
        },
        set: [
          { field: 'UF', value: env.revista.uf },
          { field: 'Canal', value: getCanal(env.revista.canal) },
        ],
      });
    },
    analyticDeny() {
      console.log('Disabled Google Analytics');
      Vue.use(VueAnalytics, {
        id: env.GA,
        router,
        ignoreRoutes: ['/login', '/404'],
        disabled: true,
        debug: {
          enabled: false,
          trace: true,
          sendHitTask: true,
        },
        autoTracking: {
          pageviewTemplate(route) {
            return {
              title: document.title,
              page: route.path,
              location: window.location.href,
            };
          },
        },
        set: [
          { field: 'UF', value: env.revista.uf },
          { field: 'Canal', value: getCanal(env.revista.canal) },
        ],
      });
    },
  },
};
